var map = {
	"./Annualcontest.png": 7742,
	"./Authorsclubfinal.png": 6940,
	"./Brosnan.jpg": 9566,
	"./Ellipse 6.png": 5275,
	"./Ellipse10.png": 1630,
	"./Ellipse11.png": 7734,
	"./Ellipse12.png": 5999,
	"./Ellipse7.png": 4191,
	"./Ellipse8.png": 1743,
	"./Ellipse9.png": 8339,
	"./FanatiXx Gold Logo.png": 3071,
	"./Group 442.png": 327,
	"./Group 443.png": 4682,
	"./Group 444.png": 2215,
	"./Group 445.png": 6916,
	"./Group 446.png": 9871,
	"./Group392.png": 304,
	"./Group393.png": 9653,
	"./Group401.png": 3259,
	"./Inkfeathers Logo.png": 960,
	"./LOGO2-061.png": 1405,
	"./Picture1.jpg": 7512,
	"./Picture2.jpg": 3281,
	"./Picture3.jpg": 3445,
	"./PngItem.png": 4479,
	"./REVIEWER.png": 5558,
	"./Rajiv.png": 1773,
	"./Readingcontest.png": 1010,
	"./Rectangle 1407.png": 7654,
	"./Rectangle 1408.png": 1027,
	"./Rectangle 1409.png": 1970,
	"./Rectangle 1446.png": 1676,
	"./Rectangle 1447.png": 5450,
	"./Rectangle 1448.png": 997,
	"./Rectangle 1449.png": 7101,
	"./Rectangle 1458.png": 6621,
	"./Rectangle 1459.png": 6509,
	"./Rectangle 1460.png": 6177,
	"./Rectangle 1461.png": 4832,
	"./Rectangle1410.png": 4262,
	"./Rectangle1443.png": 236,
	"./SCHOOL.png": 6511,
	"./STUDENT.png": 5,
	"./Tanmayee.jpg": 6923,
	"./Tejaswini.jpeg": 3586,
	"./Vector6.png": 4359,
	"./Writtingcontest.png": 241,
	"./about1.png": 1257,
	"./about2.png": 4794,
	"./about22.png": 4700,
	"./about223.jpg": 3762,
	"./about3.png": 985,
	"./aboutnew.png": 635,
	"./achiv1.png": 6442,
	"./achiv2.png": 9977,
	"./achiv3.png": 157,
	"./achiv4.png": 3713,
	"./achiv5.png": 7324,
	"./achivement.png": 206,
	"./adarsh.jpg": 4207,
	"./annual.png": 1411,
	"./banner.png": 1685,
	"./banner2.png": 9922,
	"./bookcollection.png": 6153,
	"./bookstorepic.png": 2401,
	"./bookstorepic2.png": 7280,
	"./commenticon.png": 2484,
	"./contactus.png": 5145,
	"./contactus11.jpg": 4967,
	"./dot.png": 1191,
	"./downarrow.png": 5234,
	"./imagenotfund.png": 1871,
	"./kashish.jpeg": 1016,
	"./leftarrow.png": 1857,
	"./leftcomma.png": 6610,
	"./level1.png": 8399,
	"./level2.png": 4849,
	"./level3.png": 9166,
	"./level4.png": 397,
	"./listimg.png": 3984,
	"./listimg2.png": 906,
	"./listimg3.png": 9844,
	"./new-banner1.png": 9045,
	"./new-banner2.png": 9163,
	"./new-banner3.png": 9911,
	"./news1.png": 5256,
	"./news3.png": 8881,
	"./plusicon.png": 7003,
	"./pngwing.png": 2629,
	"./pngwing2.png": 876,
	"./reading.png": 6138,
	"./readingcontestbanner.png": 8069,
	"./reviewer1.png": 6390,
	"./rightarrow.png": 6175,
	"./rightcomma.png": 5700,
	"./serviceicon.png": 9796,
	"./shivani.jpg": 1330,
	"./slider1.png": 9657,
	"./slider2.jpg": 9843,
	"./slider3.jpg": 8834,
	"./slider4.png": 278,
	"./sliderimg1.png": 4877,
	"./sliderimg2.png": 4090,
	"./sliderimg3.png": 1421,
	"./storyreadingimg1.png": 1595,
	"./team1.png": 6793,
	"./toppic1.png": 9430,
	"./toppic2.png": 77,
	"./toppic3.png": 7990,
	"./tweeter1.png": 4723,
	"./tweeter2.png": 5399,
	"./tweeter3.png": 765,
	"./tweeter4.png": 4052,
	"./videostory.png": 4349,
	"./writting.png": 3725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 733;